import { render } from "./ForYou.vue?vue&type=template&id=d8d6b5cc&scoped=true"
import script from "./ForYou.vue?vue&type=script&lang=js"
export * from "./ForYou.vue?vue&type=script&lang=js"

import "./ForYou.vue?vue&type=style&index=0&id=d8d6b5cc&scoped=true&lang=css"
import "./ForYou.vue?vue&type=style&index=1&id=d8d6b5cc&scoped=true&lang=css"

import exportComponent from "F:\\App-themes\\clickon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8d6b5cc"]])

export default __exports__